var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _polygon, _linearGradient4, _polygon2, _linearGradient5, _polygon3, _linearGradient6, _polygon4, _linearGradient7, _polygon5, _linearGradient8, _polygon6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMediaKeycloak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r4SWwybU7j4LfAsY72Au3a",
    x1: 22.223,
    x2: 25.856,
    y1: 5.68,
    y2: 40.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#626363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5b5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#4b4b4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454546"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r4SWwybU7j4LfAsY72Au3a)",
    d: "M34.412,42H13.589c-0.363,0-0.698-0.197-0.874-0.515L3.539,24.964 c-0.335-0.604-0.335-1.339,0-1.943l9.174-16.507C12.891,6.197,13.225,6,13.588,6h20.823c0.363,0,0.698,0.197,0.874,0.514L45,24 l-9.714,17.486C35.109,41.803,34.775,42,34.412,42z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r4SWwybU7j4LfAsY72Au3b",
    x1: 21.97,
    x2: 26.975,
    y1: 6.952,
    y2: 31.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#c3c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#acadad"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r4SWwybU7j4LfAsY72Au3b)",
    d: "M46,32V16c0-0.552-0.448-1-1-1H7.998 L3.54,23.021c-0.336,0.604-0.336,1.338,0,1.943L8.002,33H45C45.552,33,46,32.552,46,32z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r4SWwybU7j4LfAsY72Au3c",
    x1: 19.807,
    x2: 15.133,
    y1: 11.308,
    y2: 32.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#51e6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#28bce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094d1"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#r4SWwybU7j4LfAsY72Au3c)",
    points: "17,12 20,12 22,15 16.937,24 22,33 20,36 17,36 9.994,24"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r4SWwybU7j4LfAsY72Au3d",
    x1: 15.273,
    x2: 22.755,
    y1: 23.849,
    y2: 39.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#51e6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#4ce1f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#3ed3f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#26bbe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#0599d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094d1"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#r4SWwybU7j4LfAsY72Au3d)",
    points: "20,36 13,24 16.937,24 22,33"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r4SWwybU7j4LfAsY72Au3e",
    x1: 13.664,
    x2: 13.72,
    y1: 12.658,
    y2: 12.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#51e6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#4ce1f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#3ed3f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#26bbe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#0599d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094d1"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#r4SWwybU7j4LfAsY72Au3e)",
    points: "20,12 11.485,26.555 10,24 17,12"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r4SWwybU7j4LfAsY72Au3f",
    x1: 33.29,
    x2: 28.142,
    y1: 9.39,
    y2: 49.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#51e6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#38ccee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#0fa4d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094d1"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#r4SWwybU7j4LfAsY72Au3f)",
    points: "30.99,12 27.99,12 25.99,15 31.053,24 25.99,33 27.99,36 30.99,36 37.996,24"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r4SWwybU7j4LfAsY72Au3g",
    x1: 30.49,
    x2: 30.49,
    y1: 22.773,
    y2: 23.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#51e6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#4ce1f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#3ed3f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#26bbe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#0599d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094d1"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#r4SWwybU7j4LfAsY72Au3g)",
    points: "27.99,36 34.99,24 31.053,24 25.99,33"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r4SWwybU7j4LfAsY72Au3h",
    x1: 29.762,
    x2: 37.631,
    y1: 11.938,
    y2: 26.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#51e6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#4fe4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#48ddf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#3dd2f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#2cc1e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#17abdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094d1"
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#r4SWwybU7j4LfAsY72Au3h)",
    points: "27.99,12 35,24 36.528,21.485 37.996,24 30.99,12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaKeycloak);
export default __webpack_public_path__ + "static/media/social_media_keycloak.ab3a1d92b94ce5bbecdd0b9b11294373.svg";
export { ForwardRef as ReactComponent };